module.exports = __webpack_public_path__ + "media/images/talent/lp/ambassador/title02-b450fee3ed302295e835bda79a83b442.svg";